import dayjs from 'dayjs'

/** Local hour a "follow up on <day>" reminder fires. */
export const FOLLOW_UP_HOUR = 9

export interface FollowUpPreset {
  label: string
  days: number
}

export const FOLLOW_UP_PRESETS: FollowUpPreset[] = [
  { label: 'Tomorrow', days: 1 },
  { label: 'In 3 days', days: 3 },
  { label: 'Next week', days: 7 },
  { label: 'In 2 weeks', days: 14 },
]

/** Local time. */
export const atFollowUpHour = (date: Date): Date =>
  dayjs(date).hour(FOLLOW_UP_HOUR).minute(0).second(0).millisecond(0).toDate()

export const followUpDateFromNow = (days: number, now = new Date()): Date =>
  atFollowUpHour(dayjs(now).add(days, 'day').toDate())

/** Earliest day the picker offers: a same-day pick after FOLLOW_UP_HOUR would already be past. */
export const earliestFollowUpDay = (now = new Date()): Date =>
  dayjs(now).add(1, 'day').startOf('day').toDate()
